const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[\W_])(?=.*[A-Z])(?=.*[a-z]).{8,}$/;
const PHONE_REGEX = /^(?:\S\s*?){10,}$/;

export { EMAIL_REGEX, PASSWORD_REGEX, PHONE_REGEX };
